<div id="attribute">

    <div class="padding-11" style="overflow-x: auto;">
      <div class="editSets" fxLayout="column">
        <calsoft-list [searchRequired]="false" [displayColumnRequired]="'false'" [refreshRequired]="true" [progress]="spinner" 
          name="Associated Products" 
        style="margin-bottom: 0px;">

        <mat-table #table [dataSource]="dataSource">

       
        
            <!-- Name Column -->
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.name}} </mat-cell>
            </ng-container>

                 <!-- Position Column -->
                 <ng-container matColumnDef="sku">
                    <mat-header-cell *matHeaderCellDef>SKU</mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.sku}} </mat-cell>
                  </ng-container>

                       <!-- Position Column -->
            <ng-container matColumnDef="manageStockSeperately">
                <mat-header-cell *matHeaderCellDef>Maintain Stock Separately</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.manageStockSeperately}} </mat-cell>
              </ng-container>
        
            <!-- Weight Column -->
            <ng-container matColumnDef="managePriceSeperately">
              <mat-header-cell *matHeaderCellDef>Manage Price Separately  </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.managePriceSeperately}} </mat-cell>
            </ng-container>
        
            <!-- Symbol Column -->
            <ng-container matColumnDef="manageImageSeperately">
              <mat-header-cell *matHeaderCellDef>Manage Image Separately</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.manageImageSeperately}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="manageDescriptionSeperately">
              <mat-header-cell *matHeaderCellDef>Manage Description Separately</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.manageDescriptionSeperately}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="manageAdditionalInformationSeperately">
              <mat-header-cell *matHeaderCellDef>Manage Additional Information Separately</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.manageAdditionalInformationSeperately}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="manageNameSeperately">
              <mat-header-cell *matHeaderCellDef>Manage Name Separately</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.manageNameSeperately}} </mat-cell>
            </ng-container>
        
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table>

          <div fxLayout="row" class="pager" fxLayoutAlign="end center" fxLayoutGap="5px">
         
            <mat-paginator #paginator
            [pageSizeOptions]="pageSizeValue"
            [pageSize]="10"
          >
</mat-paginator>
          </div>
        </calsoft-list>
      </div>
      <!-- <div class="padding-top10 " fxLayoutGap="10px">
        <button [attr.guide]="'summary-btn-1' + '__' + sanitizedUrl" type="button" mat-raised-button (click)="addSelectedAttribute()">OK
        </button>
    </div> -->
    </div>
  </div>